import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DxButtonModule } from "devextreme-angular";
import { RouterModule } from "@angular/router";
import { AppGlobals } from "src/app/app.globals";
import { FeatureFlags } from "src/app/interfaces/enums/feature-flag";

type tab = {
  text: string;
  routerLink: string;
  features?: FeatureFlags[];
};

@Component({
    selector: "app-config.page",
    imports: [CommonModule, DxButtonModule, RouterModule],
    templateUrl: "./config.page.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./config.page.css"]
})
export class ConfigPageComponent implements OnInit {
  maxTabLength: number = 0;

  tabs: tab[] = [];

  constructor(private appGlobals: AppGlobals) {}

  ngOnInit(): void {
    this.calculateMaxTabLength();

    this.tabs = this.tabs.filter(
      (tab) =>
        tab.features?.every((feature) => AppGlobals.UserCan(feature)) ?? true
    );

    this.appGlobals.$headerTitle.next(
      $localize`:@@configuration:Configuration`
    );
  }

  calculateMaxTabLength() {
    this.maxTabLength =
      Math.max(...this.tabs.map((tab) => tab.text.length)) + 10;
  }
}
